// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3QehS","productName":"Table_productName__1hkom"};